import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import CustomerSelectionModal from "./CustomerSelectionModal";
import SupplierSelectionModal from "./SupplierSelectionModal";
import PartSelectionModal from "./PartSelectionModal";
import CustomerService from "../../../Customer/Controller/CustomerController";
import SupplierService from "../../../Supplier/Controller/SupplierController";
import SupplierContactService from "../../../Supplier/Controller/SupplierContactController";
import CustomerContactService from "../../../Customer/Controller/CustomerContactController";
import CustomerSiteService from "../../../Customer/Controller/CustomerSiteController";
import PurchaseOrderService from "../../Controller/PurchaseOrderController";
import DiscountTypeService from "../../../Setup/controller/DiscountTypeController/DiscountTypeController";
import { handleChange, handleSubmit } from "../../Controller/CreatePurchaseOrderController";
import CurrencyService from "../../../Setup/controller/CurrencyController/CurrencyController";
import CurrencyTextField from "../../../Jobs/View/JobForms/CurrencyTextField";
import { convertCurrency } from "./CurrencyConverter";
import VatTaxService from "../../../Setup/controller/VatTaxController/VatTaxController";
import PartService from "../../../Parts/Controller/PartController";
import HelpSite from "../../../Common/HelpLink";
import useOrderPurchase from "./useOrderPurchase";
import DeliverPurchase from "./DeliverPurchase";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import PurchaseOrderDeliveryModal from "./PurchaseOrderDelivery";
import JobSelectionModal from "./JobSelectionModal";
import JobService from "../../../Jobs/Controller/JobController";
import StockDiscountCategoryService from "../../../Parts/Controller/StockDiscountCategoryController";
import SupplierDiscountService from "../../../Supplier/Controller/SupplierDiscountController";
import SupplierCategoryDiscountService from "../../../Supplier/Controller/SupplierCategoryDiscountController"
import SupplierStockService from "../../../Supplier/Controller/SupplierStockController";
import Swal from 'sweetalert2';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ModuleService from "../../../Setup/controller/ModuleController/ModuleController";
import DescriptionModal from "../../../SaleOrder/View/SaleOrderForms/DescriptionModal";
import LeadUserDefineFieldsSection from '../../../Lead/Views/LeadForms/LeadUserDefineFieldsSection';
import JobUserDefineService from "../../../Jobs/Controller/UserDefineJobController";
import SendEmail from "../../../Common/SendEmailAttachment";
import { handleSubmit as handleUserDefineSubmit } from "../../../Jobs/Controller/CreateUserDefineController";

import CompanySetupController from "../../../SuperAdmin/Controller/Client/SACompanyListController";
import JasperReportService from '../../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../../config/axiosInstance';
import BASE_URL from "../../../../config/config";
import Draggable from 'react-draggable';
import ReportService from "../../../Setup/controller/ReportController/ReportController";
import TermsConditionService from "../../../Setup/controller/TermsConditionController/TermsConditionController";
import { PDFDocument } from "pdf-lib";
import { getMergedPDFBlob } from '../../../Common/ReportPDFService';
const MODULE_IDS = {
    Assets: 3,
    Parts: 4,
    Suppliers: 5,
    Quotations: 6,
    SalesOrders: 7,
    Purchasing: 8,
    Agreements: 9,
    Jobs: 10,
    Contacts: 15,
};
function CreatePurchaseOrder({ PurchaseOrderID, onSuccess, onClose, isLock }) {
    const navigate = useNavigate();
    const location = useLocation();
    const tableRef = useRef();
    const [errors, setErrors] = useState({});
    const [IsAuto, setIsAuto] = useState([]);
    const [currencyList, setCurrencies] = useState([]);
    const [currencySupplierSymbol1, setCurrencySupplierSymbol1] = useState('');
    const [currencyCostValue1, setCostCurrencyValue1] = useState('');
    const [BaseCurrency, setBaseCurrency] = useState('');
    const [vatTax, setVatTax] = useState('0.00');
    const [convRate, setConRate] = useState('0.00');
    const [isClosed, SetIsClosed] = useState("0");
    const [showPurchaseDeliveryModal, setshowPurchaseDeliveryModal] = useState(false);
    const [showJobSelectionModal, setshowJobSelectionModal] = useState(false);
    const [supplierTax, setSupplierTax] = useState("0.00");
    const [suppliertaxType, setSuppliertaxType] = useState("0");

    const [supplierCategorytaxType, setSupplierCategoryType] = useState("0");
    const [supplierCategoryTax, setSupplierCategoryTax] = useState("0");
    const [quantityTax, setQuantityTax] = useState("0");
    const [pdfUrl, setPdfUrl] = useState(null); // State to store the PDF URL
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [quantityBreak, setQuantityBreak] = useState();
    const [supplierStockList, setSupplierStockList] = useState([]);

    const [assignedModules, setAssignedModules] = useState(new Set());

    const [showDescriptionModal, setShowDescriptionModal] = useState(false);
    const [descriptionText, setDescriptionText] = useState("");
    const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
    const [KeyNameList, setKeyNames] = useState([]);

    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [Email, setEmail] = useState();
    const [pdfAttachment, setPdfAttachment] = useState(null); // Store PDF for Email
    const [loading, setLoading] = useState(false);
    const [isChanged, setIsChanged] = useState(false);
    const [includeTerms, setIncludeTerms] = useState(true);
    const fetchKeyNames = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const KeyNames = await JobUserDefineService.GetJobUserDefine(redirectCallback, PurchaseOrderID, "8");
            setKeyNames(KeyNames || []);

            // Initialize form data with vc_Value if available
            const initialFormData = {};
            KeyNames.forEach(keyItem => {
                if (keyItem.vc_Value) {
                    initialFormData[keyItem.vc_Name] = keyItem.vc_Value;
                }
            });

            // ✅ Merge into existing formData instead of replacing it
            setFormData(prev => ({
                ...prev,
                ...initialFormData
            }));
        } catch (error) {
            console.error('Error fetching Key Names:', error);
        }
    };

    const handleIntegerChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleDecimalChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };
    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData(prevData => ({ ...prevData, [name]: files[0] }));
    };
    const fetchCurrency = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const currencyData = await CurrencyService.GetAllCurrencies(redirectCallback);
            setCurrencies(currencyData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const fetchJob = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const jobsData = await JobService.PurchasingJobs(redirectCallback);

            setJobData(jobsData);
        } catch (error) {
            console.error('Error fetching jobs:', error);
        }
    };
    const fetchVatTax = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const vatTax = await VatTaxService.GetVatTaxLabel(redirectCallback);
            if (vatTax.length > 0) {
                setVatTax(vatTax[0].vatTax);
            }
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const getCurrentDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };
    const [formData, setFormData] = useState({
        CustomerID: 0,
        CustomerName: '',
        FK_ClientBranch_ID: 0,
        FK_ClientContact_ID: 0,
        FK_Supplier_ID: 0,
        FK_SupplierContact_ID: "0",
        vc_SupplierName: "",
        vc_AccountRef: "",
        vc_SupplierInvoice: "",
        vc_User7: "",
        AccountRef: '',
        dec_DiscountAmount: "0.00",
        mon_TotalPrice: "0.00",
        GrandTotal: "0.00",
        dec_DiscountNETTotal: "0.00",
        vc_CustomerOrderNumber: "",
        dt_PurchaseOrderDate: getCurrentDate(),
        int_DiscountType: 0,
        FK_Currency_ID: "0",
        IsPercentage: false,
        mon_TotalPriceO: "0.00",
        mon_TotalPriceGR: "0.00",
        FK_Issue_ID: "0",
        vc_User5: "",
        snt_PaymentMethod: "0",
        FK_SalesOrderType_ID: "0",
        type: "0",
        ConversionAmount: "1.00",

        HostCompanyAddress: "",
        POrderNo: "",
        Supp_Address1: "",
        Supp_City: "",
        Supp_County: "",
        Supp_Postcode: "",
        vc_Email: ""
    });

    const [CustomerList, setCustomer] = useState([]);
    const [CustomerContactList, setCustomerContact] = useState([]);
    const [CustomerSiteList, setCustomerSite] = useState([]);
    const [showCustomerModal, setShowCustomerModal] = useState(false);
    const [showSupplierModal, setShowSupplierModal] = useState(false);
    const [SupplierList, setSupplierList] = useState([]);
    const [SupplierContactList, setSupplierContact] = useState([]);
    const [PurchaseOrderTypeList, setPurchaseOrderTypeData] = useState([]);
    const { theme } = useContext(ThemeContext);
    const [partList, setPartData] = useState([]);
    const [selectedParts, setSelectedParts] = useState([]);
    const [showPartModal, setShowPartModal] = useState(false);
    const [DiscountsList, setDiscounts] = useState([]);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [bnt_OrderNumber, set_bnt_OrderNumber] = useState("");
    const [CustomerID, set_CustomerID] = useState(0);
    const [jobID, set_JobID] = useState(0);
    const [purchaseID, set_PurchaseID] = useState("");
    const [jobList, setJobData] = useState([]);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const fetchDefaultCurrency = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfCurreny = await CurrencyService.DefaultCurrency(redirectCallback);
            setBaseCurrency(listOfCurreny[0].Symbol);

        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };

    useEffect(() => {
        SetIsClosed("0");
        fetchJob();
        fetchCustomers();
        fetchSuppliers();
        fetchCurrency();
        // fetchVatTax();
        fetchDefaultCurrency();
        fetchAssignedModules();
        if (PurchaseOrderID > 0) {
            fetchPurchaseOrderDetail();
            fetchKeyNames();
        }
        else {
            resetForm();
            setSelectedParts([]);
            fetchKeyNames();
        }
        // fetchParts();
        fetchDiscount();

    }, [PurchaseOrderID]);

    useEffect(() => {

        const updatedParts = selectedParts.map(part => {
            const salesPrice = parseFloat(part.mon_StockPrice || 0);
            const netSalesPrice = parseFloat(part.net_SalesPrice || 0);
            const netVATPrice = parseFloat(part.net_VATPrice || 0);
            const quantity = parseFloat(part.vc_UnitOfSale || 0);
            const dec_Discount = parseFloat(part.dec_Discount || 0);
            const discount = (salesPrice * quantity) * ((dec_Discount) / 100);
            const total = netSalesPrice; // Assuming total is just the net sales price
            const totalVAT = netVATPrice;
            return { ...part, discount, total, totalVAT };
        });

        const totalSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.mon_StockPrice || 0), 0);
        let totalNetSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.total || 0), 0);
        let totalDiscountedAmount = updatedParts.reduce((sum, part) => sum + parseFloat(part.dec_Discount || 0), 0);
        const totalVATPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.totalVAT || 0), 0);


        if (formData.int_DiscountType === "3" || formData.int_DiscountType === 3) {
            totalDiscountedAmount = Math.round(parseFloat(totalDiscountedAmount).toFixed(2)) + Math.round(parseFloat((totalNetSalesPrice * formData.dec_DiscountAmount) / 100).toFixed(2));
            totalNetSalesPrice = (totalNetSalesPrice) * ((100 - formData.dec_DiscountAmount) / 100);

        }
        else if (formData.int_DiscountType === "4" || formData.int_DiscountType === 4) {
            totalDiscountedAmount = Math.round(totalDiscountedAmount) + Math.round(formData.dec_DiscountAmount);
            totalNetSalesPrice = totalNetSalesPrice - formData.dec_DiscountAmount;

        }
        setFormData((prevFormData) => ({
            ...prevFormData,
            dec_DiscountNETTotal: totalDiscountedAmount.toFixed(2),
            mon_TotalPrice: totalNetSalesPrice.toFixed(2),
            mon_TotalPriceO: totalVATPrice.toFixed(2),
            mon_TotalPriceG: (parseFloat(totalNetSalesPrice) + parseFloat(totalVATPrice)).toFixed(2),
            ConversionAmount: (parseFloat(totalNetSalesPrice) + parseFloat(totalVATPrice)).toFixed(2),
        }));
    }, [selectedParts, formData.int_DiscountType, formData.dec_DiscountAmount]);


    const fetchCustomers = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfCustomers = await CustomerService.GetAllCustomers(redirectCallback);
            setCustomer(listOfCustomers);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };

    const fetchDiscount = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfDiscounts = await DiscountTypeService.GetAllDiscountTypes(redirectCallback);
            setDiscounts(listOfDiscounts);
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };

    const fetchDiscountCategory = async (SupplierID) => {
        try {
            const redirectCallback = () => navigate('/');
            let listOfDiscounts = await SupplierDiscountService.GetAllSupplierDiscounts(redirectCallback, SupplierID);
            listOfDiscounts = listOfDiscounts.find(cust => cust.IsDefault === 1);
            return listOfDiscounts;
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };
    const fetchSupplierCategoryDiscount = async (StockCategoryID) => {
        try {
            const redirectCallback = () => navigate('/');
            let listOfDiscounts = await PartService.QuantityBreakDiscount(redirectCallback, StockCategoryID);

            return listOfDiscounts;
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };
    const fetchSupplierStock = async (SupplierID) => {
        try {
            const redirectCallback = () => navigate('/');
            const stockList = await SupplierStockService.SupplierStockCategory(redirectCallback, SupplierID);
            return stockList;

        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };

    const populateCustomerSiteContactAccount = async (quotation) => {

        const customerId = quotation.CustomerID;
        await fetchCustomersSites(customerId);
        await fetchCustomerContact(quotation.FK_ClientBranch_ID);

        setFormData(prev => ({
            ...prev,
            ...quotation,
            type: quotation.Type.toString(),
            CustomerID: customerId,
            CustomerName: quotation.CompanyName,
            AccountRef: quotation.AccountRef,
            FK_ClientBranch_ID: quotation.FK_ClientBranch_ID,
            FK_ClientContact_ID: quotation.FK_ClientContact_ID,
            dt_PurchaseOrderDate: new Date(quotation.dt_PurchaseOrderDate).toISOString().split('T')[0],
        }));
    };
    const handleBranchChange = async (event) => {
        const { value } = event.target;
        const branchID = event.target.value;
        setFormData({
            ...formData,
            FK_ClientBranch_ID: value,
            FK_ClientContact_ID: 0
        });
        await fetchCustomerContact(value);

    };

    const fetchCustomerContact = async (BranchID) => {
        try {

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            setCustomerContact([]);
            const listOfCustomerContacts = await CustomerContactService.GetContactByBranch(redirectCallback, BranchID);
            setCustomerContact(listOfCustomerContacts);
            if (listOfCustomerContacts.length > 0) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    FK_ClientContact_ID: listOfCustomerContacts[0].ClientContactID,
                }));
            }
        } catch (error) {
            console.error('Error fetching customer contacts:', error);
        }
    };

    const fetchCustomersSites = async (customerID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const listOfCustomerSites = await CustomerSiteService.GetAllCustomersSites(redirectCallback, customerID);
            setCustomerSite(listOfCustomerSites);
            const headOfficeSite = listOfCustomerSites.find(site => site.HeadOffice === 1);
            if (headOfficeSite) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    FK_ClientBranch_ID: headOfficeSite.ClientBranchID,
                }));
                await fetchCustomerContact(headOfficeSite.ClientBranchID);
            } else if (listOfCustomerSites.length > 0) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    FK_ClientBranch_ID: headOfficeSite.ClientBranchID,
                }));
                await fetchCustomerContact(listOfCustomerSites[0].ClientBranchID);
            }
        } catch (error) {
            console.error('Error fetching customer sites:', error);
        }
    };

    const fetchParts = async (SupplierID = 0) => {
        try {
            const redirectCallback = () => navigate('/');
            const data = await PurchaseOrderService.GetAllParts(redirectCallback, SupplierID);
            setPartData(data);
        } catch (error) {
            console.error('Error fetching parts:', error);
        }
    };

    const fetchPurchaseOrderDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (PurchaseOrderID > 0) {
                const purchaseOrderDetail = await PurchaseOrderService.GetPurchaseOrderByID(redirectCallback, PurchaseOrderID);
                const purchaseOrder = purchaseOrderDetail[0];

                if (purchaseOrder.bit_OnOrder === 1 || purchaseOrder.snt_DeliveryStatus === 2) {
                    SetIsClosed("1");
                }

                setFormData(prev => ({
                    ...prev,
                    ...purchaseOrder,
                    dt_PurchaseOrderDate: new Date(purchaseOrderDetail[0].dt_PurchaseOrderDate).toISOString().split('T')[0],
                    type: purchaseOrder.Type.toString(),
                    ConversionAmount: purchaseOrderDetail[0].mon_TotalPriceG,
                    HostCompanyAddress: purchaseOrderDetail[0].HostCompanyAddress,

                    POrderNo: purchaseOrderDetail[0].POrderNo,
                    Supp_Address1: purchaseOrderDetail[0].Supp_Address1,
                    Supp_City: purchaseOrderDetail[0].Supp_City,
                    Supp_County: purchaseOrderDetail[0].Supp_County,
                    Supp_Postcode: purchaseOrderDetail[0].Supp_Postcode,
                }));


                if (purchaseOrderDetail[0].FK_ClientBranch_ID > 0) {

                    await populateCustomerSiteContactAccount(purchaseOrderDetail[0]);

                }
                await fetchSupplierData(purchaseOrderDetail[0].FK_Supplier_ID);

            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    const fetchCustomerData = async (customerID) => {
        try {

            const redirectCallback = () => navigate('/');
            if (customerID > 0) {
                const customerData = await CustomerService.GetCustomerByID(redirectCallback, customerID);
                if (customerData.length > 0) {
                    setFormData((prevFormData) => ({
                        ...prevFormData,
                        CustomerName: customerData[0].CompanyName,
                        AccountRef: customerData[0].AccountRef
                    }));
                }


                await fetchCustomersSites(customerID);
            }
        } catch (error) {
            console.error('Error fetching customer data:', error);
        }
    };
    const fetchSupplierData = async (supplierID) => {
        try {
            const redirectCallback = () => navigate('/');
            const supplierData = await SupplierService.GetSupplierByID(redirectCallback, supplierID);
            setFormData((prevFormData) => ({
                ...prevFormData,
                vc_SupplierName: supplierData[0].vc_SupplierName,
                vc_AccountRef: supplierData[0].vc_AccountRef,
                HostCompanyAddress: supplierData[0].HostCompanyAddress,

                POrderNo: supplierData[0].POrderNo,
                Supp_Address1: supplierData[0].Supp_Address1,
                Supp_City: supplierData[0].Supp_City,
                Supp_County: supplierData[0].Supp_County,
                Supp_Postcode: supplierData[0].Supp_Postcode,
                vc_Email: supplierData[0].vc_Email,
            }));

            setVatTax(supplierData[0].dec_Rate);
            // fetchParts(supplierData[0].PK_Supplier_ID);
            setSupplierTax(supplierData[0].dec_DiscountAmount ?? 0.00);
            setSuppliertaxType(supplierData[0].FK_DiscountType_ID ?? 0);

            const SupplierStock = await fetchSupplierStock(supplierData[0].PK_Supplier_ID);
            if (SupplierStock.length > 0) {
                setSupplierCategoryType(SupplierStock[0].FK_DiscountType_ID);
                setSupplierCategoryTax(SupplierStock[0].dec_Amount);

                const StockCategryList = await StockDiscountCategoryService.GetStockByCategoryID(redirectCallback, SupplierStock[0].FK_StockCategory_ID);
                setSupplierStockList(StockCategryList);

                // Level 3 Discount
                let QuantityBreakDiscount = await fetchSupplierCategoryDiscount(SupplierStock[0].FK_StockCategory_ID);
                setQuantityBreak(QuantityBreakDiscount);
            }
            else {
                setSupplierCategoryType("0");
                setSupplierCategoryTax("0");
            }



            let ConvRate = "1.00";
            if (supplierData[0].vc_CurrencySymbol != null && supplierData[0].vc_CurrencySymbol != "" && supplierData[0].vc_CurrencySymbol != "undefined") {
                setCurrencySupplierSymbol1(supplierData[0].vc_CurrencySymbol);
                ConvRate = await convertCurrency(BaseCurrency, supplierData[0].vc_CurrencySymbol, currencyList, "0");
                setConRate(ConvRate);
            }
            else {
                setCurrencySupplierSymbol1(BaseCurrency);
                ConvRate = await convertCurrency(BaseCurrency, BaseCurrency, currencyList, "0");
                setConRate(ConvRate);
            }
            await fetchSupplierContact(supplierID);
            await fetchPurchaseOrderItems(supplierData[0].vc_CurrencySymbol, ConvRate);

        } catch (error) {
            console.error('Error fetching customer data:', error);
        }
    };
    const fetchSuppliers = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const data = await SupplierService.GetAllSuppliers(redirectCallback);
            setSupplierList(data);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };

    const fetchSupplierContact = async (supplierID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const data = await SupplierContactService.GetAllSupplierContacts(redirectCallback, supplierID);
            setSupplierContact(data);
            if (data.length > 0) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    FK_SupplierContact_ID: data[0].PK_SupplierContact_ID,
                }));
            }

        } catch (error) {
            console.error('Error fetching customer contacts:', error);
        }
    };

    const handleFieldChange = (event) => {
        const { name, value } = event.target;
        setIsChanged(true);
        // Allow input of decimal points
        const isDecimalInput = name === "dec_DiscountAmount" && /^-?\d*\.?\d*$/.test(value);
        if (!isDecimalInput && name === "dec_DiscountAmount") return;

        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value
        }));

        if (name === "int_DiscountType" || name === "dec_DiscountAmount") {
            const discountValue = name === "int_DiscountType" ? value : formData.int_DiscountType;
            let amountValue = name === "dec_DiscountAmount" ? value : formData.dec_DiscountAmount;

            if (discountValue === "0") {
                amountValue = "0";
            }

            setFormData((prevFormData) => ({
                ...prevFormData,
                int_DiscountType: discountValue,
                dec_DiscountAmount: amountValue,

            }));
        }
    };

    const calculateQuantityBreakDiscount = (quantity, StockID) => {
        const qBreak = quantityBreak.filter(discount => discount.PK_Stock_ID === StockID && ((discount.snt_QuantityBreak || 0) <= quantity))
            .sort((a, b) => (b.snt_QuantityBreak || 0) - (a.snt_QuantityBreak || 0))[0];
        if (qBreak) {
            return qBreak.dec_Discount;
        }
        else {
            return "0";
        }
    }
    // Calculation function
    const calculateNetSalesPrice = (salesPrice, discountAmount, isPercentage, dec_Quantity, dec_Discount, StockID) => {

        let TotalAmount = (salesPrice * dec_Quantity);
        if (suppliertaxType === "3" || suppliertaxType === 3) {
            TotalAmount = (TotalAmount) * ((100 - supplierTax) / 100);
        }
        if (suppliertaxType === "4" || suppliertaxType === 4) {
            TotalAmount = TotalAmount - supplierTax;
        }

        const StockDetail = supplierStockList.filter(x => x.FK_Stock_ID === StockID);
        if (StockDetail.length > 0) {
            //Customer Discount Category 1
            if (supplierCategorytaxType === "3" || supplierCategorytaxType === 3) {
                TotalAmount = (TotalAmount) * ((100 - supplierCategoryTax) / 100);
            }
            if (supplierCategorytaxType === "4" || supplierCategorytaxType === 4) {
                TotalAmount = TotalAmount - supplierCategoryTax;
            }
            //END Customer Discount Category 1
            //Level 3 Discount
            const QuanitityDiscount = calculateQuantityBreakDiscount(dec_Quantity, StockID);
            if (quantityBreak.length > 0) {
                TotalAmount = (TotalAmount) * ((parseFloat(100).toFixed(2) - parseFloat(QuanitityDiscount).toFixed(2)) / 100);
            }
        }
        //End Level 3 Discount

        return parseFloat(TotalAmount).toFixed(2);
    };
    const calculateDiscountAmount = (salesPrice, discountAmount, isPercentage, dec_Quantity, dec_Discount, StockID) => {

        let TotalAmount = (salesPrice * dec_Quantity);
        let cusDiscountAmount = 0;
        if (suppliertaxType === "3" || suppliertaxType === 3) {
            cusDiscountAmount = (TotalAmount) * (supplierTax / 100);
            TotalAmount = (TotalAmount) * ((100 - supplierTax) / 100);
        }
        if (suppliertaxType === "4" || suppliertaxType === 4) {
            cusDiscountAmount = supplierTax;
            TotalAmount = TotalAmount - supplierTax;
        }

        const StockDetail = supplierStockList.filter(x => x.FK_Stock_ID === StockID);
        if (StockDetail.length > 0) {
            if (supplierCategorytaxType === "3" || supplierCategorytaxType === 3) {
                cusDiscountAmount = Math.round(parseFloat(cusDiscountAmount).toFixed(2)) + Math.round(parseFloat((TotalAmount) * (supplierCategoryTax / 100)).toFixed(2));
                TotalAmount = (TotalAmount) * ((100 - supplierCategoryTax) / 100);
            }
            if (supplierCategorytaxType === "4" || supplierCategorytaxType === 4) {
                cusDiscountAmount = Math.round(parseFloat(cusDiscountAmount).toFixed(2)) + Math.round(parseFloat(supplierCategoryTax).toFixed(2));
                TotalAmount = TotalAmount - supplierCategoryTax;
            }
            //END Customer Discount Category 1
            //Level 3 Discount
            const QuanitityDiscount = calculateQuantityBreakDiscount(dec_Quantity, StockID);
            if (quantityBreak.length > 0) {
                cusDiscountAmount = Math.round(parseFloat(cusDiscountAmount).toFixed(2)) + Math.round(parseFloat((TotalAmount) * (QuanitityDiscount / 100)).toFixed(2));
                TotalAmount = (TotalAmount) * ((parseFloat(100).toFixed(2) - parseFloat(QuanitityDiscount).toFixed(2)) / 100);
            }
        }
        return parseFloat(cusDiscountAmount).toFixed(2);
    };
    const calculateDiscountPrice = (salesPrice, discountAmount, isPercentage, dec_Quantity, dec_Discount, StockID) => {
        const vatTaxPercent = vatTax;

        //Customer Discount
        let TotalAmount = (salesPrice * dec_Quantity);
        if (suppliertaxType === "3" || suppliertaxType === 3) {
            TotalAmount = (TotalAmount) * ((100 - supplierTax) / 100);
        }
        if (suppliertaxType === "4" || suppliertaxType === 4) {
            TotalAmount = TotalAmount - supplierTax;

        }

        const StockDetail = supplierStockList.filter(x => x.FK_Stock_ID === StockID);
        if (StockDetail.length > 0) {
            if (supplierCategorytaxType === "3" || supplierCategorytaxType === 3) {
                TotalAmount = (TotalAmount) * ((100 - supplierCategoryTax) / 100);
            }
            if (supplierCategorytaxType === "4" || supplierCategorytaxType === 4) {
                TotalAmount = TotalAmount - supplierCategoryTax;

            }
            //End Customer Discount Category 1
            //Level 3 Discount
            const QuanitityDiscount = calculateQuantityBreakDiscount(dec_Quantity, StockID);
            if (quantityBreak.length > 0) {
                TotalAmount = (TotalAmount) * ((parseFloat(100).toFixed(2) - parseFloat(QuanitityDiscount).toFixed(2)) / 100);
            }
        }
        // END Customer Discount
        let newPrice = (TotalAmount * vatTaxPercent) / 100;
        return (newPrice).toFixed(2);
    };

    const handleSalesPriceChange = (index, newSalesPrice, fieldName) => {
        if (fieldName === "mon_StockPrice") {

            const updatedParts = selectedParts.map((part, i) => {
                if (i === index) {
                    const netPrice = calculateNetSalesPrice(newSalesPrice.value, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, part.dec_Discount, part.PK_Stock_ID);
                    const VATPrice = calculateDiscountPrice(newSalesPrice.value, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, part.dec_Discount, part.PK_Stock_ID);
                    const dec_Discount = calculateDiscountAmount(newSalesPrice.value, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, part.dec_Discount, part.PK_Stock_ID);
                    return {
                        ...part,
                        mon_StockPrice: newSalesPrice.value,
                        net_SalesPrice: netPrice,
                        net_VATPrice: VATPrice,
                        dec_Discount: dec_Discount
                    };
                }
                return part;
            });
            setSelectedParts(updatedParts);

            // Calculate the sum of mon_SalesPrice and net_SalesPrice

            let totalDiscountedAmount = 0;
            if (formData.int_DiscountType === "3") {
                const totalSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.mon_StockPrice), 0);
                const totalNetSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.net_SalesPrice), 0);
                totalDiscountedAmount = totalSalesPrice - totalNetSalesPrice;
            }
            else if (formData.int_DiscountType === "4") {

                totalDiscountedAmount = updatedParts.reduce((sum, part) => sum + parseFloat(part.dec_Discount), 0);
            }
            // Update the state with the new parts and the total discounted amount
            setSelectedParts(updatedParts);
        }
        else if (fieldName === "vc_UnitOfSale") {

            const updatedParts = selectedParts.map((part, i) => {
                if (i === index) {


                    const netPrice = calculateNetSalesPrice(part.mon_StockPrice, formData.dec_DiscountAmount, formData.int_DiscountType, newSalesPrice, part.dec_Discount, part.PK_Stock_ID);
                    const VATPrice = calculateDiscountPrice(part.mon_StockPrice, formData.dec_DiscountAmount, formData.int_DiscountType, newSalesPrice, part.dec_Discount, part.PK_Stock_ID);
                    const dec_Discount = calculateDiscountAmount(part.mon_StockPrice, formData.dec_DiscountAmount, formData.int_DiscountType, newSalesPrice, part.dec_Discount, part.PK_Stock_ID);
                    return {
                        ...part,
                        vc_UnitOfSale: newSalesPrice.value,
                        net_SalesPrice: netPrice,
                        net_VATPrice: VATPrice,
                        dec_Discount: dec_Discount
                    };
                }
                return part;
            });

            // Calculate the sum of mon_SalesPrice and net_SalesPrice

            let totalDiscountedAmount = 0;
            if (formData.int_DiscountType === "3") {
                const totalSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.mon_StockPrice), 0);
                const totalNetSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.net_SalesPrice), 0);
                totalDiscountedAmount = totalSalesPrice - totalNetSalesPrice;
            }
            else if (formData.int_DiscountType === "4") {

                totalDiscountedAmount = updatedParts.reduce((sum, part) => sum + parseFloat(part.dec_Discount), 0);
            }
            // Update the state with the new parts and the total discounted amount
            setSelectedParts(updatedParts);
        }
    };
    const handleQuantityChange = (index, newSalesPrice) => {
        const updatedParts = selectedParts.map((part, i) => {
            if (i === index) {
                const netPrice = calculateNetSalesPrice(part.mon_StockPrice, formData.dec_DiscountAmount, formData.int_DiscountType, newSalesPrice, part.dec_Discount, part.PK_Stock_ID);
                const VATPrice = calculateDiscountPrice(part.mon_StockPrice, formData.dec_DiscountAmount, formData.int_DiscountType, newSalesPrice, part.dec_Discount, part.PK_Stock_ID);
                const dec_Discount = calculateDiscountAmount(part.mon_StockPrice, formData.dec_DiscountAmount, formData.int_DiscountType, newSalesPrice, part.dec_Discount, part.PK_Stock_ID);
                return {
                    ...part,
                    vc_UnitOfSale: newSalesPrice,
                    net_SalesPrice: netPrice,
                    net_VATPrice: VATPrice,
                    dec_Discount: dec_Discount
                };
            }
            return part;
        });

        // Calculate the sum of mon_SalesPrice and net_SalesPrice
        let totalDiscountedAmount = 0;
        if (formData.int_DiscountType === "3") {
            const totalSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.mon_SalesPrice), 0);
            const totalNetSalesPrice = updatedParts.reduce((sum, part) => sum + parseFloat(part.net_SalesPrice), 0);
            const totalDiscountedAmount = totalSalesPrice - totalNetSalesPrice;
        }
        else if (formData.int_DiscountType === "4") {
            totalDiscountedAmount = updatedParts.reduce((sum, part) => sum + parseFloat(part.dec_Discount), 0);
        }
        // Update the state with the new parts and the total discounted amount
        setSelectedParts(updatedParts);

    };





    const handlePartChange = (event, index, fieldName) => {
        const { value } = event.target;
        const updatedParts = [...selectedParts];
        const part = updatedParts[index];
        part[fieldName] = value;

        if (fieldName === "mon_StockPrice") {

            part.net_SalesPrice = calculateNetSalesPrice(value, formData.dec_DiscountAmount, formData.IsPercentage, part.vc_UnitOfSale, part.dec_Discount, part.PK_Stock_ID);
            part.net_VATPrice = calculateDiscountPrice(value, formData.dec_DiscountAmount, formData.IsPercentage, part.vc_UnitOfSale, part.dec_Discount, part.PK_Stock_ID);
        }


        setSelectedParts(updatedParts);
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();

        try {
            const redirectUserList = () => {
                navigate('/PurchasingList?saved=true');
            };
            formData.FK_PurchaseOrderStatus_ID = "2";
            formData.PK_PurchaseOrder_ID = PurchaseOrderID;
            formData.ID = PurchaseOrderID;
            formData.snt_PaymentMethod = "4";
            formData.mon_DeliveryNetTotal = "0.00";
            formData.mon_DeliveryVATTotal = "0.00";
            formData.FK_PurchaseOrderType_ID = "1";
            formData.snt_PurchaseType = "1";
            formData.FK_Currency_ID = "0";
            formData.currencySupplierSymbol1 = currencySupplierSymbol1;
            formData.BaseCurrency = BaseCurrency;

            const ConversionRate = await convertCurrency(BaseCurrency, currencySupplierSymbol1, currencyList, "0");
            const selectedPartsData = await Promise.all(selectedParts.map(async (detail) => {
                const convertedStockPrice = (detail.mon_StockPrice / ConversionRate);
                const convertedmon_SalesPrice = (detail.mon_SalesPrice / ConversionRate);
                const convertednet_SalesPrice = (detail.net_SalesPrice / ConversionRate);
                const converteddetailnet_VATPrice = (detail.net_VATPrice / ConversionRate);
                //   const convertedmon_SellingPrice = (detail.mon_SellingPrice / ConversionRate);
                return {
                    vc_StockCode: detail.vc_StockCode,
                    vc_Description: detail.vc_Description,
                    mon_StockPrice: convertedStockPrice, // Use the converted price
                    mon_SalesPrice: convertedmon_SalesPrice,
                    vc_UnitOfSale: detail.vc_UnitOfSale,
                    net_SalesPrice: convertednet_SalesPrice,
                    net_VATPrice: converteddetailnet_VATPrice,
                    vc_StockName: detail.vc_Description,
                    PK_Stock_ID: detail.FK_Stock_ID,
                    dec_Discount: detail.dec_Discount,
                    // mon_SellingPrice: convertedmon_SellingPrice,
                    vc_CommodityCode: detail.vc_CommodityCode,
                    dec_TaxCode: detail.dec_TaxCode,
                    dec_UnitWeight: detail.dec_UnitWeight,
                    snt_PurchaseNominalCode: detail.snt_PurchaseNominalCode,
                    dec_VAT: detail.dec_VAT,
                    mon_VATPriceForeignCurrency: detail.mon_VATPriceForeignCurrency,
                    PK_Stock_ID: detail.PK_Stock_ID,
                };
            }));

            const formDataWithParts = {
                formData: formData,
                selectedParts: selectedPartsData
            };

            const message = await handleSubmit(event, formDataWithParts, setFormData, setErrors);

            if (message == "Data saved successfully") {
                setIsChanged(false);
                localStorage.setItem('HasRecordUpdated', "1");
                await handleUserDefineSubmit({
                    JobID: PurchaseOrderID,
                    fields: KeyNameList.map(key => ({
                        PK_KeyName_ID: key.PK_KeyName_ID,
                        value: formData[key.vc_Name] || ''
                    }))
                });
                fetchKeyNames();
                setShowSuccessMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowSuccessMessage(false);
                }, 5000);
                redirectUserList();
            }
            else {
                setShowErrorMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowErrorMessage(false);
                }, 5000);

            }
        } catch (error) {
            console.error('Error submitting form:', error);
            setErrors({ submit: 'An error occurred while submitting the form. Please try again.' });
        }
    };

    const handleCustomerSelect = (customer) => {
        setFormData({
            ...formData,
            CustomerID: customer.ClientCompanyID,
            CustomerName: customer.CompanyName,
            AccountRef: customer.AccountRef,
            FK_ClientBranch_ID: 0,
            FK_ClientContact_ID: 0
        });
        fetchCustomerContact(customer.ClientCompanyID);
        fetchCustomersSites(customer.ClientCompanyID);
        setShowCustomerModal(false);
    };
    const handleJobSelect = (job) => {
        setFormData({
            ...formData,
            FK_Issue_ID: job.IssueID,
            JobNo: job.bnt_OrderNumber,
            IssueTitle: job.IssueTitle,
        });
        setshowJobSelectionModal(false);
    };

    const handleSupplierSelect = async (supplier) => {
        setIsChanged(true);
        setFormData({
            ...formData,
            FK_Supplier_ID: supplier.PK_Supplier_ID,
            vc_SupplierName: supplier.vc_SupplierName,
            vc_AccountRef: supplier.vc_AccountRef,
            vc_Email: supplier.vc_Email,
            FK_SupplierContact_ID: 0
        });

        const newCurrencySymbol = (supplier.vc_CurrencySymbol != null && supplier.vc_CurrencySymbol !== "" && supplier.vc_CurrencySymbol !== "undefined")
            ? supplier.vc_CurrencySymbol
            : BaseCurrency;
        // fetchParts(supplier.PK_Supplier_ID);
        setVatTax(supplier.dec_Rate);
        setSupplierTax(supplier.dec_DiscountAmount ?? 0.00);
        setSuppliertaxType(supplier.FK_DiscountType_ID ?? 0);


        const SupplierStock = await fetchSupplierStock(supplier.PK_Supplier_ID);
        if (SupplierStock.length > 0) {
            const redirectCallback = () => navigate('/');
            setSupplierCategoryType(SupplierStock[0].FK_DiscountType_ID);
            setSupplierCategoryTax(SupplierStock[0].dec_Amount);

            const StockCategryList = await StockDiscountCategoryService.GetStockByCategoryID(redirectCallback, SupplierStock[0].FK_StockCategory_ID);
            setSupplierStockList(StockCategryList);

            // Level 3 Discount
            let QuantityBreakDiscount = await fetchSupplierCategoryDiscount(SupplierStock[0].FK_StockCategory_ID);
            setQuantityBreak(QuantityBreakDiscount);
        }
        else {
            setSupplierCategoryType("0");
            setSupplierCategoryTax("0");
        }


        const ConversionRate = await convertCurrency(BaseCurrency, newCurrencySymbol, currencyList, "0");
        setCurrencySupplierSymbol1(newCurrencySymbol);
        setConRate(ConversionRate);
        if (PurchaseOrderID > 0) {
            await fetchPurchaseOrderItems(newCurrencySymbol, ConversionRate);
        }
        else {

            const selectedPartsData = await Promise.all(selectedParts.map(async (detail) => {
                const convertedStockPrice = (detail.mon_StockPrice * ConversionRate);
                const convertedmon_SalesPrice = (detail.mon_SalesPrice * ConversionRate);
                const convertednet_SalesPrice = (detail.net_SalesPrice * ConversionRate);
                const converteddetailnet_VATPrice = (detail.net_VATPrice * ConversionRate);
                const convertedmon_SellingPrice = (detail.mon_SellingPrice * ConversionRate);
                return {
                    vc_StockCode: detail.vc_StockCode,
                    vc_Description: detail.vc_Description,
                    mon_StockPrice: convertedStockPrice, // Use the converted price
                    mon_SalesPrice: convertedmon_SalesPrice,
                    vc_UnitOfSale: detail.vc_UnitOfSale,
                    net_SalesPrice: convertednet_SalesPrice,
                    net_VATPrice: converteddetailnet_VATPrice,
                    vc_StockName: detail.vc_Description,
                    PK_Stock_ID: detail.FK_Stock_ID,
                    dec_Discount: detail.dec_Discount,
                    mon_SellingPrice: convertedmon_SellingPrice,
                    // Map other fields as needed
                };
            }));
            setSelectedParts(selectedPartsData);
        }
        await fetchSupplierContact(supplier.PK_Supplier_ID);
        setShowSupplierModal(false);
    };

    const handlePartSelect = async (selectedPartsArray) => {
        setIsChanged(true);
        const ConversionRate = await convertCurrency(BaseCurrency, currencySupplierSymbol1, currencyList, "0");
        const convertedParts = selectedPartsArray.map(part => {
            const convertedStockPrice = (part.mon_StockPrice * ConversionRate);
            const convertedmon_SalesPrice = (part.mon_SalesPrice * ConversionRate);
            const convertednet_SalesPrice = (part.net_SalesPrice * ConversionRate);
            const converteddetailnet_VATPrice = (part.net_VATPrice * ConversionRate);
            const convertedmon_SellingPrice = (part.mon_SellingPrice * ConversionRate);

            if (formData.FK_Issue_ID > 0 && part.PK_Stock_ID > 0) {
                part.vc_Description = `${part.vc_StockCode} - ${part.vc_Description}`;
                part.PK_Stock_ID = 0;
                part.vc_StockCode = "S1";
            }

            return {
                ...part,
                mon_StockPrice: convertedStockPrice,
                mon_SalesPrice: convertedmon_SalesPrice,
                mon_SellingPrice: convertedmon_SalesPrice,
                dec_Discount: calculateDiscountAmount(convertedStockPrice, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, formData.dec_DiscountAmount, part.PK_Stock_ID),
                net_SalesPrice: calculateNetSalesPrice(convertedStockPrice, formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, formData.dec_DiscountAmount, part.PK_Stock_ID),
                net_VATPrice: calculateDiscountPrice(parseFloat(convertedStockPrice || 0), formData.dec_DiscountAmount, formData.int_DiscountType, part.vc_UnitOfSale, formData.dec_DiscountAmount, part.PK_Stock_ID),

            };
        });
        setSelectedParts(prev => [...prev, ...convertedParts]);
        setShowPartModal(false);

    };

    const fetchPurchaseOrderItems = async (currencySymbol, ConversionRate) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            if (PurchaseOrderID > 0) {
                const saleOrderDetails = await PurchaseOrderService.GetPurchaseOrderItem(redirectCallback, PurchaseOrderID);

                const selectedPartsData = await Promise.all(saleOrderDetails.map(async (detail) => {
                    const convertedStockPrice = (detail.mon_StockPrice * ConversionRate)
                    const convertedmon_SalesPrice = (detail.mon_SalesPrice * ConversionRate);
                    const convertedvc_UnitOfSale = (detail.vc_UnitOfSale * ConversionRate);
                    const convertednet_SalesPrice = (detail.net_SalesPrice * ConversionRate);
                    const converteddetailnet_VATPrice = (detail.net_VATPrice * ConversionRate);
                    const convertedmon_SellingPrice = (detail.mon_SellingPrice * ConversionRate);

                    return {
                        vc_StockCode: detail.vc_StockCode,
                        vc_Description: detail.vc_Description,
                        mon_StockPrice: convertedStockPrice, // Use the converted price
                        mon_SalesPrice: convertedmon_SalesPrice,
                        vc_UnitOfSale: detail.vc_UnitOfSale,
                        net_SalesPrice: convertednet_SalesPrice,
                        net_VATPrice: converteddetailnet_VATPrice,
                        vc_StockName: detail.vc_Description,
                        PK_Stock_ID: detail.FK_Stock_ID,
                        dec_Discount: detail.dec_Discount,
                        mon_SellingPrice: convertedmon_SellingPrice,
                        dec_Delivered: detail.dec_Delivered,
                        // Map other fields as needed
                    };
                }));

                setSelectedParts(selectedPartsData);
            }
        } catch (error) {
            console.error('Error fetching supplier details:', error);
        }
    };
    const resetForm = () => {

        setFormData({
            CustomerID: 0,
            CustomerName: '',
            FK_ClientBranch_ID: 0,
            FK_ClientContact_ID: 0,
            FK_Supplier_ID: 0,
            FK_SupplierContact_ID: "0",
            vc_SupplierName: "",
            vc_AccountRef: "",
            vc_SupplierInvoice: "",
            vc_User7: "",
            AccountRef: '',
            dec_DiscountAmount: "0.00",
            mon_TotalPrice: "0.00",
            GrandTotal: "0.00",
            dec_DiscountNETTotal: "0.00",
            vc_CustomerOrderNumber: "",
            dt_PurchaseOrderDate: getCurrentDate(),
            int_DiscountType: 0,
            FK_Currency_ID: "0",
            IsPercentage: false,
            mon_TotalPriceO: "0.00",
            mon_TotalPriceGR: "0.00",
            FK_Issue_ID: "0",
            vc_User5: "",
            snt_PaymentMethod: "0",
            FK_SalesOrderType_ID: "0",
            type: "0",
            ConversionAmount: "100.00",
            vc_Email: ""
        });
    };
    const HelpLink = localStorage.getItem('HelpLink');
    const handleRadioChange = (event) => {
        const { value } = event.target;

        // Create a base object with `type` updated
        let updatedFormData = {
            ...formData,
            type: value
        };

        // Extend `updatedFormData` with additional fields based on the selected value
        if (value === "0") {
            updatedFormData = {
                ...updatedFormData,
                FK_Issue_ID: 0,
                JobNo: "",
                IssueTitle: "",
                CustomerID: 0,
                CustomerName: "",
                AccountRef: "",
                FK_ClientBranch_ID: 0,
                FK_ClientContact_ID: 0
            };
        } else if (value === "1") {
            updatedFormData = {
                ...updatedFormData,
                FK_Issue_ID: 0,
                JobNo: "",
                IssueTitle: ""
            };
        } else if (value === "2") {
            updatedFormData = {
                ...updatedFormData,
                CustomerID: 0,
                CustomerName: "",
                AccountRef: "",
                FK_ClientBranch_ID: 0,
                FK_ClientContact_ID: 0
            };
        }

        // Update the formData state with the final object
        setFormData(updatedFormData);
    };
    const removeRow = (index) => {

        const updatedTableData = [...selectedParts];
        updatedTableData.splice(index, 1);
        setSelectedParts(updatedTableData);
    };
    const handleCurrencyChange = ({ symbol, value }) => {
        setBaseCurrency(symbol);
        setCostCurrencyValue1(value);

    };
    const handleAddRow = () => {
        const newRow = {
            PK_Stock_ID: 0,
            vc_StockCode: "S1",            // Default Product Code
            vc_Description: "Free Text",            // Default Description (Free text)
            mon_SalesPrice: "0.00",        // Default Sale Price
            vc_UnitOfSale: "0.00",
            dec_Discount: "0.00",
            net_SalesPrice: "0.00",
            net_VATPrice: "0.00",
            mon_StockPrice: "0.00",
            dec_Quantity: "0",
            mon_SellingPrice: "0.00",
            isNew: true  // This will help identify newly added rows
        };
        setSelectedParts([...selectedParts, newRow]);
    };


    ///// Order and Deliver Work

    const PurchaseOrderDetail = async (PurchaseOrderID) => {
        try {
            const redirectCallback = () => navigate('/');

            if (PurchaseOrderID > 0) {
                const purchaseOrderDetail = await PurchaseOrderService.GetPurchaseOrderByID(redirectCallback, PurchaseOrderID);
                const purchaseOrder = purchaseOrderDetail[0];
                return purchaseOrder;
            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    const { handleOrderPurchase } = useOrderPurchase(PurchaseOrderID);
    const handleCreateOrderPurchase = async (event) => {

        event.stopPropagation();
        const ID = PurchaseOrderID;
        if (ID > 0) {
            const purchaseOrderDetail = await PurchaseOrderDetail(ID);
            if (purchaseOrderDetail.bit_OnOrder === 1) {
                Swal.fire(
                    '',
                    'The Selected Purchase Order is already Ordered.',
                    'Warning'
                );
            }
            else {
                Swal.fire({
                    title: 'Are you sure?',
                    text: "Create order from the selected Purchase order!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Order it!'
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        const postData = await handleOrderPurchase(event, ID);
                        if (postData === "Data saved successfully") {
                            Swal.fire(
                                '',
                                'Purchase Order ordered Sucessfully.',
                                'success'
                            );

                            onClose();

                        }

                    }
                });
            }
        }
        else {
            Swal.fire(
                '',
                'Please select a row to order.',
                'warning'
            );
        }
    }

    const { handleDeliverPurchase } = DeliverPurchase(PurchaseOrderID);
    const handleCreateDeliverPurchase = async (event) => {
        event.stopPropagation();
        if (PurchaseOrderID > 0) {
            const ID = PurchaseOrderID;
            const purchaseOrderDetail = await PurchaseOrderDetail(ID);
            if (purchaseOrderDetail.bit_OnOrder === 0) {
                Swal.fire(
                    '',
                    'The Selected Purchase Order is not Ordered. Please order the Purchase order first',
                    'warning'
                );
            }
            else if (purchaseOrderDetail.snt_DeliveryStatus === 2) {
                Swal.fire(
                    '',
                    'The Selected Purchase Order is already delivered',
                    'warning'
                );
            }
            else {
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, deliver!'
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        try {

                            setshowPurchaseDeliveryModal(true);
                            set_bnt_OrderNumber("");
                            set_CustomerID(0);
                            set_JobID(0);
                            set_PurchaseID("");
                            await setPartData([]);
                            set_bnt_OrderNumber(purchaseOrderDetail.bnt_OrderNumber);
                            set_CustomerID(purchaseOrderDetail.CustomerID !== null ? purchaseOrderDetail.CustomerID : 0);
                            set_JobID(purchaseOrderDetail.FK_Issue_ID !== null ? purchaseOrderDetail.FK_Issue_ID : 0);
                            set_PurchaseID(ID);
                            const PurchaseOrderItemsList = await handleDeliverPurchase(event, ID);
                            await setPartData(PurchaseOrderItemsList);

                        } catch (error) {

                            Swal.fire(
                                'Error!',
                                'There was a problem deleting the record.',
                                'error'
                            );
                        }
                    }
                });
            }
        }
        else {
            Swal.fire(
                '',
                'Please select a row to deliver.',
                'Warning'
            );
        }
    };
    const handleCloseDeliveryModal = () => {
        setshowPurchaseDeliveryModal(false);
    };
    const handleSuccess = async () => {
        await fetchPurchaseOrderDetail();
        setshowPurchaseDeliveryModal(false);
    };

    const truncateTextPdf = (text, maxLength = 25) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const [imageData, setImageData] = useState(null);
    const [reportLink, setReportLink] = useState('');
    const [reportTitle, setReportTitle] = useState('');
    const [error, setError] = useState(null);

    useEffect(() => {
        // Load image as base64
        const loadImage = async () => {
            try {
                const ClientID = localStorage.getItem('CompanyID');
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };

                const companySetup = await CompanySetupController.GetCompanyByID(redirectCallback, ClientID);
                const fileName = companySetup[0]?.FileName; // Check if fileName exists

                let imageUrl;
                if (!fileName) {
                    // Use fallback image if fileName is null or empty
                    imageUrl = 'assets/img/resources/trent.PNG';
                } else {
                    imageUrl = `${BASE_URL}/uploads/${ClientID}/Admin/CompanySetup/${fileName}`;
                }
                debugger;
                console.log("Fetching image from:", imageUrl); // Debugging

                const response = await fetch(imageUrl, {
                    method: 'GET',
                    mode: 'cors', // Ensure CORS mode
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    console.error(`Error fetching image: ${response.statusText}`);
                    return;
                }

                const blob = await response.blob();
                const reader = new FileReader();
                reader.onloadend = () => {
                    setImageData(reader.result); // Convert to base64
                };
                reader.readAsDataURL(blob);
            } catch (error) {
                console.error("Error loading image:", error);
            }
        };

        loadImage();
    }, []);


    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const CompanyID = localStorage.getItem("CompanyID");
    const fetchAssignedModules = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const modules = await ModuleService.GetCompanyModules(redirectCallback, "en", CompanyID);
            const moduleSet = new Set(modules.map(m => m.PK_SearchModule_ID)); // Store assigned module IDs in a Set
            setAssignedModules(moduleSet);
        } catch (error) {
            console.error('Error fetching assigned modules:', error);
        }
    };

    const generatePDF = async (event) => {
        event.stopPropagation();

        try {
            const blob = await getMergedPDFBlob({
                moduleId: "8",
                navigate,
                currentInputValues: {
                    ID: PurchaseOrderID
                },
                defaultReportID: 118,
                setReportLink,
                setReportTitle,
                setError
            });

            const finalUrl = URL.createObjectURL(blob);

            setPdfUrl(finalUrl);
            setShowPdfModal(true);

            localStorage.setItem('HasRecordUpdated', "1");

        } catch (err) {
            console.error(err);
        }
    };
    const generatePDFForEmail = async (termsFlag) => {
        try {
            setLoading(true);

             const blob = await getMergedPDFBlob({
                moduleId: "8",
                navigate,
                currentInputValues: {
                    paramPurchaseOrderId: PurchaseOrderID
                },
                defaultReportID: 118,
                setReportLink,
                setReportTitle,
                setError
            });

            const file = new File([blob], 'Invoice.pdf', {
                type: 'application/pdf'
            });

            setPdfAttachment(file);
            setIsEmailModalOpen(true);

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleCloseEmailModal = async () => {
        setIsEmailModalOpen(false);
    };

    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <form onSubmit={handleFormSubmit} style={{
                // IE/Edge
            }}>
                <div

                >
                    <table style={{ width: "100%" }}>
                        <tbody>
                            <tr>
                                <td style={{ width: "13%" }}><label htmlFor="Type" style={{ float: "right" }}></label></td>
                                <td style={{ width: "37%" }}>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td>
                                                <input style={{ position: "relative" }} className="form-check-input" type="radio" name="type" value="0" checked={formData.type == '0'}
                                                    onChange={handleRadioChange} disabled={isClosed === '1' || isClosed === 1}
                                                />
                                            </td>
                                            <td>
                                                <label className="col-form-label">Stock Item</label>
                                            </td>
                                            {(assignedModules.has(MODULE_IDS.Jobs) &&
                                                <>
                                                    <td>
                                                        <input style={{ position: "relative" }} className="form-check-input" type="radio" name="type" value="1" checked={formData.type == '1'}
                                                            onChange={handleRadioChange} disabled={isClosed === '1' || isClosed === 1}
                                                        />
                                                    </td>
                                                    <td><label className="col-form-label">Job No.</label></td>
                                                </>
                                            )}
                                            <td>
                                                <input style={{ position: "relative" }} className="form-check-input" type="radio" name="type" value="2" checked={formData.type == '2'}
                                                    onChange={handleRadioChange} disabled={isClosed === '1' || isClosed === 1}
                                                />
                                            </td>
                                            <td><label className="col-form-label">Drop Shipment</label></td>
                                        </tr>
                                    </table>
                                </td>
                                <td style={{ width: "14%" }}></td>
                                <td style={{ width: "36%" }}></td>



                            </tr>
                            {
                                formData.type === '2' && (
                                    <>
                                        <tr>
                                            <td>
                                                <label htmlFor="CustomerID" style={{ float: "right" }}>Company <span style={{ "color": "red" }}>*</span></label>
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="CustomerID"
                                                    name="CustomerID"
                                                    value={formData.CustomerName}
                                                    onClick={() => setShowCustomerModal(true)}
                                                    readOnly
                                                    disabled={isClosed === '1' || isClosed === 1}
                                                />
                                                {errors.CustomerID && <div style={{ color: 'red' }}>{errors.CustomerID}</div>}
                                            </td>

                                            <td><label htmlFor="vc_SerialNumber" style={{ float: "right" }}>Site <span style={{ "color": "red" }}>*</span></label></td>
                                            <td>
                                                <select name="FK_ClientBranch_ID" className='form-control' value={formData.FK_ClientBranch_ID} onChange={handleBranchChange} disabled={isClosed === '1' || isClosed === 1}>
                                                    <option value="0">Select Site</option>
                                                    {CustomerSiteList.map((site) => (
                                                        <option key={site.ClientBranchID} value={site.ClientBranchID}>
                                                            {site.BranchName}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.FK_ClientBranch_ID && <div style={{ color: 'red' }}>{errors.FK_ClientBranch_ID}</div>}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label htmlFor="FK_ClientContact_ID" style={{ float: "right" }}>Contact <span style={{ "color": "red" }}>*</span></label>
                                            </td>
                                            <td>
                                                <select name="FK_ClientContact_ID" className='form-control' value={formData.FK_ClientContact_ID} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}>
                                                    <option value="0">Select Contact</option>
                                                    {CustomerContactList.map((contact) => (
                                                        <option key={contact.ClientContactID} value={contact.ClientContactID}>
                                                            {contact.Title} {contact.FirstName} {contact.SurName}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.FK_ClientContact_ID && <div style={{ color: 'red' }}>{errors.FK_ClientContact_ID}</div>}
                                            </td>
                                            <td>
                                                <label htmlFor="AccountRef" style={{ float: "right" }} disabled={isClosed === '1' || isClosed === 1}>Account Ref &nbsp;&nbsp;</label>
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="AccountRef"
                                                    name="AccountRef"
                                                    value={formData.AccountRef}
                                                    onChange={(e) => setFormData({ ...formData, AccountRef: e.target.value })}
                                                    readOnly
                                                />
                                            </td>

                                        </tr>
                                    </>
                                )
                            }
                            {
                                formData.type === '1' && (
                                    <>
                                        <tr>
                                            <td><label htmlFor="IssueID" style={{ float: "right" }}>Select Job <span style={{ "color": "red" }}>*</span></label></td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="IssueID"
                                                    name="IssueID"
                                                    value={formData.JobNo}
                                                    onClick={() => setshowJobSelectionModal(true)}
                                                    readOnly
                                                    disabled={isClosed === '1' || isClosed === 1}
                                                />

                                            </td>
                                        </tr>

                                    </>
                                )
                            }
                            <tr>
                                <td><label htmlFor="FK_Supplier_ID" style={{ float: "right" }}>Supplier <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="FK_Supplier_ID"
                                        name="FK_Supplier_ID"
                                        value={formData.vc_SupplierName}
                                        onClick={() => setShowSupplierModal(true)}
                                        readOnly
                                        disabled={isClosed === '1' || isClosed === 1}
                                    />
                                    {errors.FK_Supplier_ID && <div style={{ color: 'red' }}>{errors.FK_Supplier_ID}</div>}
                                </td>
                                <td><label htmlFor="FK_SupplierContact_ID" style={{ float: "right" }}>Contact <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <select name="FK_SupplierContact_ID" className='form-control' value={formData.FK_SupplierContact_ID} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}>
                                        <option value="0">Select Contact</option>
                                        {SupplierContactList.map((supContact) => (
                                            <option key={supContact.PK_SupplierContact_ID} value={supContact.PK_SupplierContact_ID}>
                                                {supContact.vc_Title} {supContact.vc_FirstName} {supContact.vc_SurName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.FK_SupplierContact_ID && <div style={{ color: 'red' }}>{errors.FK_SupplierContact_ID}</div>}
                                </td>

                            </tr>
                            <tr>

                                <td><label htmlFor="vc_AccountRef" style={{ float: "right" }}>Account Ref &nbsp;&nbsp;</label></td>
                                <td>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="vc_AccountRef"
                                        name="vc_AccountRef"
                                        value={formData.vc_AccountRef}
                                        onChange={(e) => setFormData({ ...formData, vc_AccountRef: e.target.value })}
                                        readOnly
                                        disabled={isClosed === '1' || isClosed === 1}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_CustomerOrderNumber" style={{ float: "right" }}>Supplier Invoice No &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_SupplierInvoice" value={formData.vc_SupplierInvoice} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.vc_SupplierInvoice && <div style={{ color: 'red' }}>{errors.vc_SupplierInvoice}</div>}
                                </td>
                                <td><label htmlFor="dt_PurchaseOrderDate" style={{ float: "right" }}>Due Date &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="date" className="form-control" name="dt_PurchaseOrderDate" value={formData.dt_PurchaseOrderDate} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.dt_PurchaseOrderDate && <div style={{ color: 'red' }}>{errors.dt_PurchaseOrderDate}</div>}
                                </td>
                            </tr>

                            <tr>
                                <td><label htmlFor="vc_User7" style={{ float: "right" }}>Reference &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_User7" value={formData.vc_User7} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />

                                </td>
                                <td><label htmlFor="" style={{ float: "right" }}><span style={{ "color": "red" }}></span></label></td>
                                <td>

                                </td>
                            </tr>
                            {KeyNameList.length > 0 && (
                                <>
                                    <LeadUserDefineFieldsSection
                                        KeyNameList={KeyNameList}
                                        formData={formData}
                                        errors={errors}
                                        handleInputChange={handleFieldChange}
                                        handleDecimalChange={handleDecimalChange}
                                        handleIntegerChange={handleIntegerChange}
                                        handleFileChange={handleFileChange}
                                    />
                                </>
                            )}
                        </tbody>
                    </table>
                    <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                        <div className='col-sm-12' >
                            <table className="table datatable table-bordered">
                                <thead>
                                    <tr>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Product Code</th>
                                        <th className="no-wrap" style={{ "width": "15%" }}>Description</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Cost Price</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Unit Sales Price</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Quantity</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Discount</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Delivered</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>Net</th>
                                        <th className="no-wrap" style={{ "width": "10%" }}>VAT</th>
                                        <th className="no-wrap" style={{ "width": "5%" }}>Actions</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>

                        <div className='col-sm-12' style={{ "overflowY": "auto", "maxHeight": "150px", "marginTop": "-10px" }}>
                            <table className="table datatable table-bordered">
                                <tbody>
                                    {selectedParts.map((part, index) => (
                                        <tr key={index}>
                                            <td className="no-wrap" style={{ "width": "10%" }}>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={part.vc_StockCode}
                                                    readOnly="true"
                                                    onChange={(e) => handlePartChange(e, index, 'vc_StockCode')}
                                                />
                                            </td>
                                            <td className="no-wrap" style={{ "width": "15%" }}>
                                                <div
                                                    onMouseEnter={(e) => {
                                                        const rect = e.target.getBoundingClientRect();
                                                        setModalPosition({ top: rect.top + window.scrollY - 50, left: rect.left });
                                                        setDescriptionText(part.vc_Description);
                                                        setShowDescriptionModal(true);
                                                    }}
                                                    onMouseLeave={() => setShowDescriptionModal(false)}
                                                >
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={part.vc_Description}
                                                        onChange={(e) => {
                                                            const updatedPart = { ...part, vc_Description: e.target.value };
                                                            const updatedParts = [...selectedParts];
                                                            updatedParts[index] = updatedPart;
                                                            setSelectedParts(updatedParts);
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <CurrencyTextField initialCurrencySymbol={currencySupplierSymbol1} initialCurrencyValue={part.mon_StockPrice ?? 0}
                                                    currencyList={currencyList}
                                                    onCurrencyChange={(newValue) => handleSalesPriceChange(index, newValue, 'mon_StockPrice')} />
                                            </td>
                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <CurrencyTextField
                                                    initialCurrencySymbol={currencySupplierSymbol1}
                                                    initialCurrencyValue={part.mon_SalesPrice ?? 0}
                                                    currencyList={currencyList}
                                                    onCurrencyChange={(newValue) => {
                                                        const updatedPart = { ...part, mon_SalesPrice: newValue };
                                                        const updatedParts = [...selectedParts];
                                                        updatedParts[index] = updatedPart;
                                                        setSelectedParts(updatedParts);
                                                    }}
                                                    disabled={true}
                                                />

                                            </td>
                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={part.vc_UnitOfSale}
                                                    onChange={(e) => handleQuantityChange(index, e.target.value)}
                                                />
                                            </td>
                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <CurrencyTextField
                                                    initialCurrencySymbol={currencySupplierSymbol1}
                                                    initialCurrencyValue={part.dec_Discount ?? 0}
                                                    currencyList={currencyList}
                                                    disabled={true}
                                                />
                                            </td>

                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={part.dec_Delivered}
                                                    disabled={true}
                                                />
                                            </td>


                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <CurrencyTextField
                                                    initialCurrencySymbol={currencySupplierSymbol1}
                                                    initialCurrencyValue={part.net_SalesPrice ?? 0}
                                                    currencyList={currencyList}
                                                    onCurrencyChange={(newValue) => {
                                                        const updatedPart = { ...part, net_SalesPrice: newValue };
                                                        const updatedParts = [...selectedParts];
                                                        updatedParts[index] = updatedPart;
                                                        setSelectedParts(updatedParts);
                                                    }}
                                                    disabled={true}
                                                />
                                            </td>
                                            <td className="no-wrap" style={{ "width": "10%" }}>
                                                <CurrencyTextField
                                                    initialCurrencySymbol={currencySupplierSymbol1}
                                                    initialCurrencyValue={part.net_VATPrice ?? 0}
                                                    currencyList={currencyList}
                                                    onCurrencyChange={(newValue) => {
                                                        const updatedPart = { ...part, net_VATPrice: newValue };
                                                        const updatedParts = [...selectedParts];
                                                        updatedParts[index] = updatedPart;
                                                        setSelectedParts(updatedParts);
                                                    }}
                                                    disabled={true}
                                                />
                                            </td>
                                            <td className="no-wrap" style={{ "width": "5%" }} style={{ "textAlign": "right" }}>
                                                {((isClosed != '1' || isClosed != 1) &&
                                                    <button style={{ "background": "none", "border": "none" }} className={`text-danger ${parseInt(isLock) > 0 ? 'disabled' : ''}`} disabled={isLock.toString() === "1" || localStorage.getItem('LicenseExpired') == "1"} onClick={() => removeRow(index)}>
                                                        <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        </div>
                    </div>
                    {/* Add more form fields as needed */}

                    <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                        <label htmlFor="int_DiscountType" className="col-sm-2 col-form-label">Discount</label>
                        <div className="col-sm-4">
                            <select name="int_DiscountType" className='form-control' value={formData.int_DiscountType} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}>
                                <option value="0">Select Discount</option>
                                {DiscountsList.map((discount) => (
                                    <option key={discount.PK_DiscountType_ID} value={discount.PK_DiscountType_ID}>
                                        {discount.vc_Name}
                                    </option>
                                ))}
                            </select>
                        </div>

                    </div>
                    <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                        <label htmlFor="dec_DiscountAmount" className="col-sm-2 col-form-label">Discount Amount</label>
                        <div className="col-sm-4">
                            <input type="text" className="form-control" name="dec_DiscountAmount" value={formData.dec_DiscountAmount} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                        </div>
                        <label htmlFor="dec_DiscountNETTotal" className="col-sm-2 col-form-label">Discount</label>
                        <div className="col-sm-2">
                            <CurrencyTextField
                                initialCurrencySymbol={currencySupplierSymbol1}
                                initialCurrencyValue={formData.dec_DiscountNETTotal ?? 0}
                                currencyList={currencyList}
                                disabled={true}
                            />
                        </div>

                        <div className="col-sm-2">

                        </div>
                    </div>
                    <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                        <label htmlFor="dec_DiscountAmount" className="col-sm-6 col-form-label"></label>
                        <label htmlFor="int_DiscountType" className="col-sm-2 col-form-label">Orders Total</label>
                        <div className="col-sm-2">
                            <CurrencyTextField
                                initialCurrencySymbol={currencySupplierSymbol1}
                                initialCurrencyValue={formData.mon_TotalPrice ?? 0}
                                currencyList={currencyList}
                                disabled={true}
                            />
                        </div>

                        <div className="col-sm-2">

                            <CurrencyTextField
                                initialCurrencySymbol={currencySupplierSymbol1}
                                initialCurrencyValue={formData.mon_TotalPriceO ?? 0}
                                currencyList={currencyList}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="row mb-3" style={{ "marginLeft": "0px" }}>
                        <label htmlFor="dec_DiscountAmount" className="col-sm-6 col-form-label"></label>
                        <label htmlFor="int_DiscountType" className="col-sm-2 col-form-label">Grand Total</label>
                        <div className="col-sm-2">

                            <CurrencyTextField
                                initialCurrencySymbol={currencySupplierSymbol1}
                                initialCurrencyValue={formData.mon_TotalPriceG ?? 0}
                                currencyList={currencyList}
                                disabled={true}
                            />
                        </div>

                        <div className="col-sm-2">

                            <CurrencyTextField
                                initialCurrencySymbol={BaseCurrency}
                                initialCurrencyValue={parseFloat(formData.mon_TotalPriceG ?? 0) / parseFloat(convRate).toFixed(2)}
                                currencyList={currencyList}
                                disabled={true}
                            />
                        </div>
                    </div>
                </div >
                <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                    <div className="col-sm-8">
                        {(assignedModules.has(MODULE_IDS.Parts) &&
                            <button style={{ background: "#00796B" }} type="button" className={`btn btn-primary ${parseInt(isLock) > 0 ? 'disabled' : ''}`} onClick={() => setShowPartModal(true)} disabled={isClosed === '1' || isClosed === 1 || isLock.toString() === "1" || !assignedModules.has(MODULE_IDS.Parts || localStorage.getItem('LicenseExpired') == "1")}>
                                <i className="icofont-plus" aria-hidden="true"> Add Item </i>
                            </button>
                        )}
                        <button style={{ "marginLeft": "5px", background: "#0288D1" }} type="button" className={`btn btn-secondary ${parseInt(isLock) > 0 ? 'disabled' : ''}`} onClick={handleAddRow} disabled={isClosed === '1' || isClosed === 1 || isLock.toString() === "1" || localStorage.getItem('LicenseExpired') == "1"}>
                            <i className="icofont-plus" aria-hidden="true">Add Text</i>
                        </button>
                        <button style={{ "marginLeft": "5px", background: "#EF6C00" }} type="button" className={`btn btn-success ${parseInt(isLock) > 0 ? 'disabled' : ''}`} onClick={(event) => handleCreateOrderPurchase(event, PurchaseOrderID)} disabled={isClosed === '1' || isClosed === 1 || PurchaseOrderID === 0 || PurchaseOrderID === "0" || isLock.toString() === "1" || localStorage.getItem('LicenseExpired') == "1"}>
                            <img style={{ "width": "10px" }} src="assets/img/icons/btnIssuesD.png" alt="Add icon" /> Order
                        </button>
                        <button style={{ "marginLeft": "5px", background: "#004D40" }} type="button" className={`btn btn-dark ${parseInt(isLock) > 0 ? 'disabled' : ''}`} onClick={(event) => handleCreateDeliverPurchase(event, PurchaseOrderID)} disabled={PurchaseOrderID === 0 || PurchaseOrderID === "0" || isLock.toString() === "1" || localStorage.getItem('LicenseExpired') == "1"}>
                            <img style={{ "width": "10px" }} src="assets/img/icons/sale.png" alt="Add icon" />  Deliver
                        </button>

                    </div>
                    <div className="col-sm-4">
                        <button onClick={() => onClose(isChanged)} type="button" className={`btn btn-danger`} style={{ float: "right", "marginLeft": "5px" }}>
                            <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                        </button>
                        <button type="submit" className={`btn btn-primary ${parseInt(isLock) > 0 ? 'disabled' : ''}`} style={{ "float": "right", "marginLeft": "5px" }} disabled={isClosed === '1' || isClosed === 1 || isLock.toString() === "1" || localStorage.getItem('LicenseExpired') == "1"}>
                            <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />
                            {PurchaseOrderID > 0 ? ' Update' : ' Save'}

                        </button>
                        <button style={{ "marginLeft": "5px", "float": "right" }} type="button" className="btn btn-secondary" onClick={generatePDF}>
                            <img src="assets/img/resources/printer-icon.png" alt="Add icon" style={{ height: "10px" }} />  Print
                        </button>
                        <button style={{ "marginLeft": "5px", "float": "right" }} type="button" className="btn btn-email" onClick={generatePDFForEmail}>
                            <i className="icofont-email" aria-hidden="true"></i> Email
                        </button>

                    </div>
                </div>
            </form >
            {showPdfModal && pdfUrl && (
                <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">PDF Report</h5>
                                    <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            )}
            {
                (showDescriptionModal &&
                    <DescriptionModal
                        show={showDescriptionModal}
                        text={descriptionText}
                        position={modalPosition}
                    />
                )
            }
            {
                showPartModal &&
                <PartSelectionModal
                    show={showPartModal}
                    onClose={() => setShowPartModal(false)}
                    parts={partList}
                    onSelectPart={handlePartSelect}
                    ClientCompanyID={CustomerID}
                />
            }
            <CustomerSelectionModal
                show={showCustomerModal}
                onClose={() => setShowCustomerModal(false)}
                customers={CustomerList}
                onSelectCustomer={handleCustomerSelect}
            />
            <SupplierSelectionModal
                show={showSupplierModal}
                onClose={() => setShowSupplierModal(false)}
                suppliers={SupplierList}
                onSelectSupplier={handleSupplierSelect}
            />
            {
                showPurchaseDeliveryModal && bnt_OrderNumber &&
                <PurchaseOrderDeliveryModal
                    show={showPurchaseDeliveryModal}
                    OnSuccess={handleSuccess}
                    onClose={handleCloseDeliveryModal}
                    parts={partList}
                    setParts={setPartData}
                    bnt_OrderNumber={bnt_OrderNumber}
                    purchaseID={purchaseID}
                    CustomerID={CustomerID}
                    jobID={jobID}
                />
            }
            {
                showJobSelectionModal &&
                <JobSelectionModal
                    show={showJobSelectionModal}
                    onClose={() => setshowJobSelectionModal(false)}
                    jobList={jobList}
                    onSelectJob={handleJobSelect}
                />
            }
            {
                isEmailModalOpen && (

                    <SendEmail
                        onClose={handleCloseEmailModal}
                        ToEmail={formData.vc_Email}
                        pdfAttachment={pdfAttachment}
                        setPdfAttachment={setPdfAttachment}   // ✅ ADD THIS
                        getMergedPDFBlob={getMergedPDFBlob}   // ✅ ADD THIS
                        ReportName="PurchaseOrder.pdf"
                    />
                )
            }

        </div >


    );
}
export default CreatePurchaseOrder;

